module.exports = __webpack_public_path__ + "img/arconnect.8da8cc08.svg";